import Core from './Core.component';
import * as error from './error';
import * as config from './config';
import * as locales from './locales';
import * as session from './session';
export { error, config, locales, session };
export default Core;
